<div *ngIf="tags" class="pipeline-tags-container row no-gutters mr-10px over-me">
    <ng-container *ngFor="let tag of tags; let i = index">
        <div *ngIf="!hiddenAll || i < 5" class="pipeline-tag mr-5px">{{ tag }}</div>
    </ng-container>
    <button *ngIf="tags.length > 4" class="btn btn-link size-s ml-5px" (click)="showAllToggle()">
        {{ hiddenAll ? 'Show all' : 'Hide' }}
    </button>
</div>
